var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-card"},_vm._l((_vm.machinesData),function(item,index){return _c('Card',{key:index,staticClass:"cards",attrs:{"translate":"no","index":index,"item":item.name,"score":item.score,"photo":_vm.photo[`${item.id}`]},on:{"modal-toggle":function($event){return _vm.$emit('render-single-machine-page', index)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }